// Offering patterns: search list, declare or clear an override, run derivation
export const FETCH_OFFERING_PATTERNS = 'DP_FETCH_OFFERING_PATTERNS';
export const FETCH_OFFERING_PATTERNS_SUCCESS = 'DP_FETCH_OFFERING_PATTERNS_SUCCESS';
export const FETCH_OFFERING_PATTERNS_ERROR = 'DP_FETCH_OFFERING_PATTERNS_ERROR';
export const SAVE_OFFERING_PATTERN = 'DP_SAVE_OFFERING_PATTERN';
export const SAVE_OFFERING_PATTERN_SUCCESS = 'DP_SAVE_OFFERING_PATTERN_SUCCESS';
export const SAVE_OFFERING_PATTERN_ERROR = 'DP_SAVE_OFFERING_PATTERN_ERROR';
// Terms whose season the planner inferred from the start month (no SeasonalDesignation)
export const FETCH_SEASON_GAPS = 'DP_FETCH_SEASON_GAPS';
export const FETCH_SEASON_GAPS_SUCCESS = 'DP_FETCH_SEASON_GAPS_SUCCESS';
export const FETCH_SEASON_GAPS_ERROR = 'DP_FETCH_SEASON_GAPS_ERROR';
